"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AddPropertyDialogModule = /** @class */ (function () {
    function AddPropertyDialogModule() {
    }
    return AddPropertyDialogModule;
}());
exports.AddPropertyDialogModule = AddPropertyDialogModule;
